import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { useTheme } from '../contexts/ThemeContext';
import PredictionBubble from './PredictionBubble';

const YearContainer = styled(motion.div)`
  margin-bottom: 3rem;
  width: 100%;
`;

const YearHeader = styled.div`
  position: relative;
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  width: 100%;
`;

const YearLine = styled.div`
  flex: 1;
  height: 2px;
  background: ${props => props.theme.colors.timelineAxis};
  border-radius: 1px;
`;

const YearLabel = styled.div`
  background: ${props => props.theme.colors.background};
  color: ${props => props.theme.colors.text};
  font-size: 1.5rem;
  font-weight: 700;
  padding: 0 1.5rem;
  border: 2px solid ${props => props.theme.colors.border};
  border-radius: 8px;
  margin-right: 1rem;
  min-width: 80px;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
    padding: 0 1rem;
    min-width: 70px;
  }
`;

const PredictionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
  width: 100%;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 0.8rem;
  }
  
  @media (min-width: 769px) and (max-width: 1024px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }
  
  @media (min-width: 1025px) {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }
`;

const YearSection = ({ year, predictions, onPredictionClick }) => {
  const { themeData } = useTheme();
  return (
    <YearContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <YearHeader>
        <YearLabel theme={themeData}>{year}</YearLabel>
        <YearLine theme={themeData} />
      </YearHeader>
      
      <PredictionsGrid>
        {predictions.map((prediction, index) => (
          <PredictionBubble
            key={prediction.id}
            prediction={prediction}
            onClick={() => onPredictionClick(prediction)}
            delay={index * 0.1}
          />
        ))}
      </PredictionsGrid>
    </YearContainer>
  );
};

YearSection.propTypes = {
  year: PropTypes.number.isRequired,
  predictions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onPredictionClick: PropTypes.func.isRequired
};

export default YearSection; 